/*
  // an AssetWindow is a window of assets, which is a subset of the assets in a repository
  // use this to keep track of the loading status of each window
  // usually, each call to repository.loadAssets will load a window of assets
  type AssetWindow = {
    windowIndex: number,
    windowSize: number,
    //  status: string,
    ... // any other properties as needed, which will be passed to the repository
  }
*/

//
export const WindowStatus = {
  loading: 'loading',
  loaded: 'loaded',
  error: 'error',
};
